import { helper as buildHelper } from '@ember/component/helper';
import { get } from '@ember/object';
import { DATA_ATTRIBUTES } from 'sh-www/constants/data-attributes';

/**
 * Takes what type of data attribute and which value and returns the constant.
 * 
 * @param {String} path
 * @returns {string}
 */
export const getDataAttribute = ([path]) => get(DATA_ATTRIBUTES, path) ?? undefined;

export default buildHelper(getDataAttribute);

